import React, { FC } from 'react';

export const ArrowDown: FC = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.256 8a.727.727 0 0 0-.506.223l-6.752 5.753-6.75-5.753A.727.727 0 1 0 4.22 9.251l7.265 6.266a.726.726 0 0 0 1.027 0l7.265-6.266a.727.727 0 0 0-.52-1.25Z"
      fill="#02315B"
      stroke="#02315B"
    />
  </svg>
);
